<template>
  <div
    class="conversation-sentiment p-2"
    :class="{ 'd-none': !show }"
  >
    <div :id="`conversationSentimentGraph-${conversationId}`"></div>
    <div
      v-if="show && !hasData"
      class="conversation-sentiment--placeholder bg-white-custom"
    >
      No Data
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { EventBus } from "@/events/eventBus";

export default {
  name: "ConversationSentiment",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    conversationId: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      hasData: false,
    };
  },
  created() {
    EventBus.$on("update-sentiment-score", (data) => {
      const { isNew, data: sentimentScore, conversationId } = data;
      if (conversationId === this.conversationId) {
        this.hasData = true;
        this.$emit("updated");
      }
    });
  },
  methods: {
  },
};
</script>

<style lang="scss">
.conversation-sentiment {
  width: 100%;
  min-height: 400px;
  position: relative;
  .apexcharts-theme-dark,
  .apexcharts-theme-light {
    >svg.apexcharts-svg {
      background: transparent !important;
    };
  }
  &--placeholder {
    position: absolute;
    left: 0.5rem;
    top: 0.5rem;
    z-index: 2;
    width: calc(100% - 1rem);
    height: calc(100% - 1rem);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
